import AdBlockDTO from "@domains/dto/AdBlockDTO";
import OfferingsDTO from "@domains/dto/OfferingsDTO";
import HomePageOfferingDTO from "@domains/dto/AllOfferingsDTO";
import WebinarDTO from "@domains/dto/WebinarDTO";
import InvestorDTO from "@domains/dto/InvestorDTO";
import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
class HomeRepository {
    constructor(commonQuotesHomePageRepository, http) {
        this.commonQuotesHomePageRepository = commonQuotesHomePageRepository;
        this.http = http;
    }
    async getWebinarData() {
        try {
            const webinarData = await this.http.request({
                method: "GET",
                url: urlConfig.home + "webinars",
            });
            if (webinarData) {
                const webinar = webinarData.data.webinars.map((webi) => new WebinarDTO(webi));
                return webinar;
            }
        }
        catch (error) {
            return [];
        }
    }
    async getNewUpdatesData() {
        try {
            const adBlockData = await this.http.request({
                method: "GET",
                url: urlConfig.home + "ad-blocks",
            });
            if (adBlockData) {
                var adBlockDataList = adBlockData.data.map((adblock) => new AdBlockDTO(adblock));
                return adBlockDataList;
            }
        }
        catch (error) {
            return [];
        }
    }
    async getHomePageOfferingsData() {
        try {
            return await this.fetchOfferings();
        }
        catch (error) {
            const emptyData = {
                primary: [],
                secondary: [],
                tertiary: [],
            };
            return emptyData;
        }
    }
    async fetchOfferings() {
        try {
            const offeringsData = await this.http.request({
                method: "GET",
                url: urlConfig.home + "offerings",
            });
            if (offeringsData) {
                var primary = offeringsData.data.home_page_Offering.primary.map((offerings) => new OfferingsDTO(offerings));
                var secondary = offeringsData.data.home_page_Offering.secondary.map((offerings) => new OfferingsDTO(offerings));
                var tertiary = offeringsData.data.home_page_Offering.tertiary.map((offerings) => new OfferingsDTO(offerings));
            }
            let AllOfferingsData = new HomePageOfferingDTO(primary, secondary, tertiary);
            return AllOfferingsData;
        }
        catch (error) {
            const emptyData = {
                primary: [],
                secondary: [],
                tertiary: [],
            };
            return emptyData;
        }
    }
    async getNewOnEdelData() {
        try {
            return await this.commonQuotesHomePageRepository.getNewOnEdelData();
        }
        catch (error) {
            return [];
        }
    }
    async getMarketNewsData() {
        try {
            return this.commonQuotesHomePageRepository.getMarketNewsData();
        }
        catch (error) {
            return [];
        }
    }
    async getInvestorData() {
        try {
            const investorData = await this.http.request({
                method: "GET",
                url: urlConfig.home + "better-investors",
            });
            if (investorData) {
                var investorDataList = investorData.data.betterInvestor.map((investor) => new InvestorDTO(investor));
                return investorDataList;
            }
            else {
                return [];
            }
        }
        catch (error) {
            return [];
        }
    }
    async getServerKey() {
        // const url = new URL(commonConfigURL.serverKey);
        // const webinarData = await this.http.makeApiCall({
        //   method: "GET",
        //   url: url.toString(),
        // });
    }
}
export default HomeRepository;
